module.exports = __webpack_public_path__ + "static/movieStillImage-b713b391cba805807e4d6a70ead45dc7.jpg";